<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("faq.menu.layout") }} </template>
        <template #sidebarMain>
            <CardToggle :title="$t('faq.layout.layout')">
                <div class="space-y-5">
                    <FormVariants
                        :title="$t('faq.layout.view_type')"
                        :variants="layouts"
                        v-model="faq.layout"
                    />
                    <FormToggleSm :title="$t('faq.layout.show_search')" v-model="faq.showSearch" />
                    <FormToggleSm :title="$t('faq.layout.show_nav')" v-model="faq.showNav" />
                    <FormToggleSm :title="$t('love.wall.show_footer')" v-model="faq.showFooter" />
                    <FormVariants
                        :title="$t('faq.layout.text_align')"
                        :variants="textAligns"
                        v-model="faq.textAlign"
                    />
                    <FormInput
                        v-if="faq.layout === 'board'"
                        :title="$t('love.wall.min_width')"
                        v-model="faq.width"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('faq.layout.content')">
                <div class="space-y-5">
                    <FormInput
                        id="faqNavTitle"
                        :title="$t('faq.layout.nav_title')"
                        v-model="faq.navTitle"
                    />
                    <FormInput id="faqTitle" :title="$t('shared.title')" v-model="faq.title" />
                    <div id="faqSubtitle">
                        <FormRichText
                            :title="$t('shared.subtitle')"
                            v-model="faq.subtitle"
                            :rows="2"
                        />
                    </div>
                </div>
            </CardToggle>
            <CardToggle v-if="faq.socials" :title="$t('faq.layout.socials')">
                <div id="faqSocials">
                    <SocialsList @edit="$emit('editSocial', $event)" />
                </div>
            </CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormVariants, FormToggleSm, FormInput, FormRichText } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import SocialsList from "./SocialsList.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    name: "LayoutMain",
    components: {
        PageSidebar,
        FormVariants,
        CardToggle,
        FormToggleSm,
        FormInput,
        FormRichText,
        SocialsList,
        cSaveButton,
    },
    setup() {
        useFocusOnQueryField();
    },
    computed: {
        ...mapState("faq", ["faq", "hasChanges"]),
        ...mapGetters("faq", ["layouts"]),
    },
    emimts: ["editSocial"],
    data() {
        return {
            textAligns: [
                { value: "left", label: this.$t("faq.layout.left") },
                { value: "center", label: this.$t("faq.layout.center") },
                { value: "right", label: this.$t("faq.layout.right") },
            ],
        };
    },
    methods: {
        ...mapActions("faq/projects", ["saveSnapshot"]),
    },
};
</script>
